import emailJS from "@/components/emailJS/emailJS.js";

//email form
let send_name = "";
let send_email = "";
let send_phone = "";
let send_msg = "";

let isVerify = false;

let checkCaptcha = function (jsonData) {
    send_name = !(jsonData.name) == true ? "" : jsonData.name;
    send_email = !(jsonData.email) == true ? "" : jsonData.email;
    send_phone = !(jsonData.phone) == true ? "" : jsonData.phone;
    send_msg = !(jsonData.msg) == true ? "" : jsonData.msg;

    grecaptcha.render('recaptcha', {
        'sitekey': '6LcelAEqAAAAALDmbFRC3pHgsr2k4Xr0BiXQFcfh',
        'callback': verifyCallback,
        // 'theme': 'dark'
    });
};

let verifyCallback = function (response) {
    if(!!response){
        isVerify = true;
        sendForm();
    }
};

let getIsVerify = function(){
    return isVerify
}

let sendForm = function(){
    let domSendForm = top.window.document.getElementsByName("sendForm");

    if(domSendForm.length > 0){
        // DomSendForm[0].submit();
        //문의 메일
        emailJS.sendMail(send_name,send_email,send_phone,send_msg);
    }

    let domCard1 = top.window.document.getElementsByName("card1");
    let domCard2 = top.window.document.getElementsByName("card2");

    if(domCard2.length > 0){        
        domCard1[0].style.display = "none";
        domCard2[0].style.display = "block";
    }


}

const CAPTCHA = { checkCaptcha, getIsVerify };

export default CAPTCHA;